import { Box, Button, Stack, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Link } from "@mui/material";
import tratativaDeDatas from "../../../../../../helpers/tratativaDeDatas";
import { useMemo, useState } from "react";
import DialogDetalheFechamento from "../DialogDetalheFechamento";
import StatusAnimated from "../../../../../../components/StatusAnimated";
import { useQuery, useQueryClient } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { TFechamentos } from "../../../../../../types/api/financeiro/pesquisar-fechamentos";
import LoadingApiQuery from "../../../../../../components/LoadingApiQuery";
import AddIcon from '@mui/icons-material/Add';
import DialogAddFechamento from "../DialogAddFechamento";
import DialogDetalheFechando from "../DialogDetalheFechando";

export default function ProximosFechamentos() {

    const [openModalAdd, setOpenModalAdd] = useState<boolean>(false)
    const [openDetalheModal, setOpenDetalheModal] = useState<number | null>(null)
    const [openDetalheFechando, setOpenDetalheFechando] = useState<number | null>(null)
    const queryClient = useQueryClient()
    
    //queries e mutations
    const { data, isFetching } = useQuery({
        queryKey: ['pesquisar-proximos-fechamentos'],
        queryFn: () => axiosClient.get("/financeiro/conta-corrente-consumo/pesquisar-fechamentos", {
            params: {
                status_contem: ['Pendente', 'Fechando']
            }
        }),
        cacheTime: 0,
        keepPreviousData: false,
        refetchInterval: openDetalheModal ? false : 60000,
        refetchOnWindowFocus: false
    });

    const dataProximosFechamentos: TFechamentos[] = useMemo(() => data?.data.data || [], [data])
    //

    return (
        <>
            <Box component={Paper} p={2}>
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                    <Typography variant="h6">Próximos fechamentos</Typography>

                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setOpenModalAdd(true)}
                    >
                        <AddIcon />
                        Adicionar
                    </Button>
                </Stack>
                {
                    isFetching &&
                    <LoadingApiQuery />
                }
                {
                    !isFetching && dataProximosFechamentos &&
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Configuração</b></TableCell>
                                    <TableCell><b>Fechamento em</b></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    dataProximosFechamentos.map((item, index) => {
                                        return (
                                            <TableRow key={index}
                                                sx={{
                                                    '&:last-child td, &:last-child th': {
                                                        border: 0,
                                                    }
                                                }}>

                                                <TableCell>
                                                    <Link
                                                        component="button"
                                                        underline="always"
                                                        onClick={() => item.status === 'Fechando' 
                                                            ? setOpenDetalheFechando(item.id)
                                                            : setOpenDetalheModal(item.id)}
                                                        sx={{
                                                            textAlign: 'left'
                                                        }}
                                                    >
                                                        {item.nome}
                                                    </Link>
                                                </TableCell>
                                                <TableCell>
                                                    {tratativaDeDatas(item.data_fechamento)}
                                                </TableCell>
                                                <TableCell>
                                                    <StatusAnimated status={item.status} />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
                {
                    !isFetching && (dataProximosFechamentos.length === 0) &&
                    <Box display={'flex'} width={'100%'} justifyContent={'center'} mt={2} >
                        <Typography variant="body1" sx={{ opacity: 0.6 }}>Nenhum fechamento encontrado</Typography>
                    </Box>
                }
            </Box>

            {
                openModalAdd &&
                <DialogAddFechamento
                    open={openModalAdd}
                    handleClose={() => setOpenModalAdd(false)}
                    handleSucessAddFechamento={(id) => {
                        setOpenModalAdd(false);
                        setOpenDetalheModal(id);
                    }}
                />
            }

            {
                openDetalheModal &&
                <DialogDetalheFechamento
                    isEdit
                    id={openDetalheModal}
                    open={Boolean(openDetalheModal)}
                    onClose={() => setOpenDetalheModal(null)}
                />
            }

            {
                openDetalheFechando &&
                <DialogDetalheFechando
                    id={openDetalheFechando}
                    open={Boolean(openDetalheFechando)}
                    onClose={() => {
                        setOpenDetalheFechando(null)
                        queryClient.invalidateQueries({ queryKey: ['pesquisar-proximos-fechamentos'] })
                        queryClient.invalidateQueries({ queryKey: ['pesquisar-ultimos-fechamentos'] })
                    }}
                />
            }
        </>
    )
}
